<div class="info-box" *ngIf="showInfoBox && streamProvider === 'playsight'">
  <div class="info-text">
    {{ infoBoxText }}
  </div>
  <img class="info-box-image" src="../../../assets/img/playsight-info-box-graphic.png">
</div>

<div [style.margin-top.px]="showInfoBox ? 0 : 45" class="wrapper" [ngClass]="{'wrapper-canada': streamProvider === 'canada'}">
  <div class="flex-row" *ngIf="!showQrCode">
    <!-- Participants -->
    <div *ngIf="streamProvider === 'canada'" id="canadaLogo" class="flex-column">
      <div class="canada-logo">
        <img src="../../../assets/img/logo/canada/logo.png">
      </div>
    </div>

    <!-- Participants -->
    <div id="participants" class="flex-column participant wrap-text">
      <ng-template ngFor let-side let-i="index" [ngForOf]="match.sides">
          <div>
            <span #participant>
              <ng-template ngFor let-player let-j="index" [ngForOf]="side.players">
                {{ getParticipantName(player.participant, i + 1, j) }}
              </ng-template>
            </span>
            <span *ngIf="tie" class="team">{{ getTeamName(i + 1) }}</span>
        </div>
      </ng-template>
    </div>

    <!-- Server / Winner -->
    <div class="flex-column" style="text-align: right;">
      <div style="height: 46px;">
        <ion-icon class="icon" [ngClass]="{'icon-canada': streamProvider === 'canada'}" [hidden]="server?.sideNumber !== 1 || match.matchStatus !=='IN_PROGRESS'" name="tennisball"></ion-icon>
        <ion-icon class="icon winning-checkmark" [ngClass]="{'icon-canada': streamProvider === 'canada'}" *ngIf="match.winningSide === 1" name="checkmark"></ion-icon>
      </div>

      <div>
        <ion-icon class="icon" [ngClass]="{'icon-canada': streamProvider === 'canada'}" [hidden]="server?.sideNumber !== 2 || match.matchStatus !=='IN_PROGRESS'" name="tennisball"></ion-icon>
        <ion-icon class="icon winning-checkmark" [ngClass]="{'icon-canada': streamProvider === 'canada'}" *ngIf="match.winningSide === 2" name="checkmark"></ion-icon>
      </div>
    </div>

    <!-- Retirement / Incomplete -->
    <div *ngIf="isRetiredOrIncomplete" class="flex-column" style="text-align: right;">
      <div class="scorebox">
        {{ statusSide1 }}
      </div>

      <div class="scorebox">
        {{ statusSide2 }}
      </div>
    </div>

    <!-- Games -->
    <ng-template *ngIf="match?.sets?.length" ngFor let-set let-i="index" [ngForOf]="match?.sets">
        <div id="games" class="flex-column ion-text-center">
          <div class="scorebox" [class]="{'winning': set.winningSide === 1 }">
            {{ match | gameScore:{setIndex: i, sideNumber: 1} }}<sup>{{ scoreboardService.getTiebreakScore(match, i, 1) }}</sup>
          </div>

          <div class="scorebox" [class]="{'winning': set.winningSide === 2 }">
            {{ match | gameScore:{setIndex: i, sideNumber: 2} }}<sup>{{ scoreboardService.getTiebreakScore(match, i, 2) }}</sup>
          </div>
        </div>
    </ng-template>

    <!-- Points -->
    <div *ngIf="showPoints" id="points" class="flex-column">
      <div  class="points points-top" [ngClass]="{'canada-background-color-secondary': streamProvider === 'canada', 'points-top-canada': streamProvider === 'canada'}">
        {{ pointScoreSide1 }}
      </div>

      <div class="points points-bottom" [ngClass]="{'canada-background-color-secondary': streamProvider === 'canada', 'points-bottom-canada': streamProvider === 'canada'}">
        {{ pointScoreSide2 }}
      </div>
    </div>

  </div>

  <div class="flex-row" *ngIf="showQrCode">
    <!-- Server / Winner -->
    <div class="qr-code">
      <qrcode [qrdata]="link" [width]="80" [hegiht]="80" [errorCorrectionLevel]="'M'"></qrcode>
    </div>

    <div class="qr-info">
        <span class="qr-text-top">SCAN THE QR CODE</span><br />
        <span class="qr-text-bottom">TO SEE THE MATCH RESULTS</span>
    </div>
  </div>
</div>
<div *ngIf="streamProvider === 'playsight'" style="max-height: 40px; width: 129px;" class="flex-row">
  <img src="../../../assets/img/playsight-logo.png">
</div>










